import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { ref, onMounted, watchEffect } from 'vue'
import { useRoute } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'layout',
  setup(__props) {

const route = useRoute()
const showFooter = ref(true)
onMounted(() => {
  if (route.name === 'contact') {
    showFooter.value = false
  } else {
    showFooter.value = true
  }
})
watchEffect(() => {
  if (route.name === 'contact') {
    showFooter.value = false
  } else {
    showFooter.value = true
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header),
    _createVNode(_component_router_view),
    _createVNode(Footer)
  ]))
}
}

})